/**
 * @param {string} printContent 
 * @param {Object} [options]
 * @param {Object} [options.downloadIndicatorRef]
 * @param {number} [options.iframeRemovalDelay=1000]
 * @param {number} [options.renderDelay=300]
 */
export const executePrint = (printContent, options = {}) => {
    const { downloadIndicatorRef, iframeRemovalDelay = 1000, renderDelay = 300 } = options;

    const iframe = document.createElement('iframe');
    Object.assign(iframe.style, {
        position: 'fixed',
        left: '-9999px',
        top: '0',
        width: '230mm',
        height: '300mm',
        visibility: 'hidden',
        border: '0'
    });
    document.body.appendChild(iframe);

    iframe.contentDocument.write(printContent);
    iframe.contentDocument.close();

    iframe.onload = async () => {
        await new Promise(resolve => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setTimeout(resolve, renderDelay);
                });
            });
        });

        await downloadIndicatorRef?.current?.completeDownload();

        try {
            if (typeof iframe.contentWindow.__fitLabels === 'function') {
                iframe.contentWindow.__fitLabels();
            }
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        } catch (e) {
            console.error('Print error:', e);
        }
        setTimeout(() => iframe.remove(), iframeRemovalDelay);
    };
};
